import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components';

const HeaderDropdownButtonWrapper = styled.div`
  box-sizing: border-box;
  font-size: 1.6rem;
  padding: 0.5em;
  cursor: ${(props) => (props.showChevron ? 'pointer' : 'default')};
  text-decoration: none;
  border: none;
  background-color: transparent;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: var(--color-white);
  #hdb-title {
    margin-right: ${(props) => (props.showChevron ? '1rem' : '0px')};
  }
  #hdb-chevron-down {
    display: unset;
  }
  #hdb-chevron-up {
    display: none;
  }
  &:hover {
    #hdb-chevron-down {
      display: none;
    }
    #hdb-chevron-up {
      display: unset;
    }
  }
`;

const HeaderDropdownButton = ({ title, showChevron = true, ...props }) => {
  return (
    <HeaderDropdownButtonWrapper
      id={props.id}
      className={props.className}
      showChevron={showChevron}
    >
      <div id="hdb-title">{title}</div>
      {showChevron ? (
        <div id="hdb-chevron-down">
          <FontAwesomeIcon icon="chevron-down" />
        </div>
      ) : null}
      {showChevron ? (
        <div id="hdb-chevron-up">
          <FontAwesomeIcon icon="chevron-up" />
        </div>
      ) : null}
    </HeaderDropdownButtonWrapper>
  );
};

export default HeaderDropdownButton;
